import { Button } from "@components";
import styles from "@styles/containers/oraculo/customer-drawer/data-tab.module.scss";

import classNames from "classnames";
import { If } from "shared/components/control-statements";
import CustomerMarkupsDrawer from "./CustomerMarkupsDrawer";
import { useState } from "react";
const css = classNames.bind(styles);

export default function CustomerMarkups({ customer, loadCustomer }) {
  const [openMarkups, setOpenMarkups] = useState(false);

  const markups = customer?.ocdp_tags || [];

  return (
    <div className={styles.customerMarkups}>
      <p className={styles.title}>Marcações do cliente ({markups.length})</p>
      <If cond={(markups || []).length > 0}>
        <div className={styles.tags}>
          {(markups || []).map((tag) => (
            <div className={styles.tag}>
              <div
                className={styles.color}
                style={{ backgroundColor: tag.color }}
              />
              <i className="fal fa-tags" style={{ color: tag.color }} />
              <p>{tag.name}</p>
            </div>
          ))}
        </div>
      </If>

      <If cond={markups.length === 0}>
        <Button
          onClick={() => setOpenMarkups(true)}
          className={css({ "w-100": markups.length === 0, "gap-10": true })}
        >
          <i className="fal fa-plus" />
          <span>Adicionar marcação</span>
        </Button>
      </If>

      <If cond={markups.length > 0}>
        <Button
          onClick={() => setOpenMarkups(true)}
          className={css({ "w-100": markups.length === 0, "gap-10": true })}
          design="default-3"
        >
          <i className="fal fa-plus" />
          <span>Gerenciar marcações</span>
        </Button>
      </If>

      <CustomerMarkupsDrawer
        open={openMarkups}
        onClose={() => setOpenMarkups(false)}
        customer={customer}
        loadCustomer={loadCustomer}
      />
    </div>
  );
}
